import React, { ReactElement } from "react";
import { Sidebar } from "@/components/Sidebar/Sidebar";
import "./Layout.scss";

type Props = {
  children: ReactElement;
};

export const Layout: React.FC<Props> = ({ children }) => {
  return (
    <div className="layout">
      <Sidebar />
      <main className="layout-main">{children}</main>
    </div>
  );
};
